import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { AuthService } from '../authentication/auth.service';
import { Observable, throwError, TimeoutError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { Router } from '@angular/router';

const DEFAULT_TIMEOUT_MS = 30_000;

const ENDPOINT_TIMEOUTS: { pattern: RegExp; ms: number }[] = [
  { pattern: /\/projects\/upload(\?|$)/, ms: 5 * 60_000 },
  { pattern: /\/projects\/finalize(\?|$)/, ms: 5 * 60_000 },
  { pattern: /\/projects\/start(\?|$)/, ms: 60_000 },
  { pattern: /\/projects\/download/, ms: 10 * 60_000 },
  { pattern: /\/projects\/net-leads\/download/, ms: 10 * 60_000 },
  { pattern: /\/download\/leads/, ms: 10 * 60_000 },
];

function timeoutFor(url: string): number {
  for (const entry of ENDPOINT_TIMEOUTS) {
    if (entry.pattern.test(url)) return entry.ms;
  }
  return DEFAULT_TIMEOUT_MS;
}

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {

  constructor(private authService: AuthService, private router: Router, private injector: Injector) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.authService = this.injector.get(AuthService);

    let tokenizedReq = req;
    if (this.authService.getToken()) {
      tokenizedReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${this.authService.getToken()}`
        }
      });
    }

    return next.handle(tokenizedReq).pipe(
      timeout(timeoutFor(req.url)),
      catchError((error: any) => {
        if (error instanceof TimeoutError) {
          const timeoutErr = new HttpErrorResponse({
            error: { message: 'Request timed out — the server is unreachable or too slow. Please retry.' },
            status: 0,
            statusText: 'Timeout',
            url: req.url
          });
          return throwError(() => timeoutErr);
        }
        if (error instanceof HttpErrorResponse) {
          if (error.status === 401) {
            this.authService.logout();
            this.router.navigate(['/login']);
          } else if (error.status === 403) {
            alert('Access Denied: You do not have the necessary permissions.');
            this.router.navigate(['/unauthorized']);
          }
        }
        return throwError(() => error);
      })
    );
  }
}
